import {Partner} from './partner';
import {Risk} from './risk';

export const TYPE_PARTNERS = 'partners';
export const TYPE_THRESHOLD = 'threshold';

export interface RiskRate {
  uuid: string;
  type: string;
  partners: Partner[];
  thresholdFrom?: number;
  thresholdTo?: number;
  risk: Risk;
  ratePaid: string;
}
